import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import AppContent from './views/AppContent.vue';
import Recipes from './views/Recipes.vue';
import Search from './views/Search.vue';
import GroceryList from './views/GroceryList.vue';
import Settings from './views/Settings.vue';
import CategoryList from './components/CategoryList.vue';
import CatRecipeList from './components/CatRecipeList.vue';
import EditCategories from './components/EditCategories.vue';
import ViewRecipe from './components/ViewRecipe.vue';
import EditRecipe from './components/EditRecipe.vue';
import NewRecipe from './components/NewRecipe.vue';
import ImportRecipe from './components/ImportRecipe.vue';
import ExportRecipe from './components/ExportRecipe.vue';
import Suggestions from './components/Suggestions.vue';
import GeneralSettings from './components/GeneralSettings.vue';
import PersonalSettings from './components/PersonalSettings.vue';
import LocalSettings from './components/LocalSettings.vue';
import UserSettings from './components/UserSettings.vue';
import About from './components/About.vue';
import UsedSoftware from './components/UsedSoftware.vue';

import store from './store';
import i18n from './i18n';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/login',
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/app',
            name: 'app',
            component: AppContent,
            meta: {
                requiresAuth: true,
            },
            children: [
                {
                    path: 'recipes',
                    component: Recipes,
                    children: [
                        {
                            path: '',
                            name: 'recipes',
                            component: CategoryList,
                        },
                        {
                            path: 'categories/view/:id',
                            component: CatRecipeList,
                        },
                        {
                            path: 'new',
                            name: 'newRecipe',
                            component: NewRecipe,
                            /*meta: {
                                title: $t('NewRecipe') + ' | Kulinari',
                            },*/
                        },
                        {
                            path: 'view/:id',
                            component: ViewRecipe,
                        },
                        {
                            path: 'edit/:id',
                            component: EditRecipe,
                        },
                    ],
                },
                {
                    path: 'categories/edit',
                    component: EditCategories,
                },
                {
                    path: 'import',
                    name: 'import',
                    component: ImportRecipe,
                },
                {
                    path: 'export',
                    name: 'export',
                    component: ExportRecipe,
                },
                {
                    path: 'search',
                    name: 'search',
                    component: Search,
                },
                {
                    path: 'suggestions',
                    name: 'suggestions',
                    component: Suggestions,
                },
                {
                    path: 'grocerylist',
                    name: 'groceryList',
                    component: GroceryList,
                },
                {
                    path: 'settings',
                    name: 'settings',
                    component: Settings,
                    children: [
                        {
                            path: 'personal',
                            name: 'personalSettings',
                            component: PersonalSettings,
                        },
                        {
                            path: 'local',
                            name: 'localSettings',
                            component: LocalSettings,
                        },
                        {
                            path: 'general',
                            name: 'generalSettings',
                            component: GeneralSettings,
                        },
                        {
                            path: 'users',
                            name: 'userSettings',
                            component: UserSettings,
                        },
                        {
                            path: 'about',
                            name: 'about',
                            component: About,
                        },
                        {
                            path: 'used-software',
                            name: 'usedSoftware',
                            component: UsedSoftware,
                        },
                    ],
                },
            ],
        },
    ],
});


router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (localStorage.getItem('accessToken') == null) {
            next({
                path: '/login',
            });
            store.state.forwardRoute = to.fullPath;
        } else {
            next();
        }
    } else {
        next();
    }

/*
    const nearestWithTitle = to.matched.slice().reverse().find((r) => r.meta && r.meta.title);
    const nearestWithMeta = to.matched.slice().reverse().find((r) => r.meta && r.meta.metaTags);
    const previousNearestWithMeta = from.matched.slice().reverse().find((r) => r.meta && r.meta.metaTags);
    if (nearestWithTitle) {
        document.title = nearestWithTitle.meta.title;
    }
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el) => {
        if (el.parentNode) {
            el.parentNode.removeChild(el);
        }
    });
    if (!nearestWithMeta) {
        return next();
    }
    nearestWithMeta.meta.metaTags.map((tagDef: any) => {
        const tag = document.createElement('meta');
        Object.keys(tagDef).forEach((key) => {
            tag.setAttribute(key, tagDef[key]);
        });
        tag.setAttribute('data-vue-router-controlled', '');
        return tag;
    })
    .forEach((tag: any) => document.head.appendChild(tag));

    next();
*/
});

export default router;
